import { LOCATION_CHANGE } from 'connected-react-router';
import { createMiddleware } from '@shared/redux';
import { loadPlatformStatus } from '@domain/platform/status/platform-status.services';
import { showErrorToast } from '@shared/toasts';
import { PLATFORM_STATUS_ERROR_MESSAGE } from '@domain/platform/status/platform-status.constants';

export const platformStatusMiddleware = createMiddleware({
    [LOCATION_CHANGE]: () => loadPlatformStatus()
        .then(() => [])
        .catch(() => [
            showErrorToast({
                message: PLATFORM_STATUS_ERROR_MESSAGE,
                options: {
                    autoClose: false,
                },
            }),
        ]),
});
